module.exports = __webpack_public_path__ + "img/GB-ENG.cd19764c.svg";